export default "__VITE_ASSET__Cua3sLno__"